import { UserAdapters } from '../adapters';
import { UsersApi } from '../clients';

/**
 * The calling admin's own GoTu Admin record, display-ready.
 *
 * Reuses the table row adapter rather than adding a near-identical one: `/me`
 * returns the same `GetInternalUserResponse` shape as a list row, and the
 * homepage needs the same resolved `roleLabel` the table does. One adapter
 * keeps the two surfaces showing the same words for the same slug.
 *
 * @returns {Promise<import('../types/User').IInternalUserRowViewEntity>}
 */
export const getInternalUserMe = async () => {
  const response = await UsersApi.getInternalUserMe();

  return UserAdapters.toInternalUserRowViewEntity(response);
};
